
<div id="primary">
  <div id="content">
    <ng-content></ng-content>
    <div class="bottom-scroll-fix"></div>
  </div>
</div>
